module.exports = __webpack_public_path__ + "static/media/recortes_home_03.5cc14a4a.jpg";